export default __webpack_public_path__ + "static/media/applicant_grey.b8a34391.svg";